var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRealpriceMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Logo_Real_Price_Constraste",
    "data-name": "Logo / Logo_Real Price_Constraste",
    transform: "translate(-815.927 -1330.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotipo",
    transform: "translate(815.927 1330.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bg",
    d: "M-130.039-1512.9h55v55h-55Z",
    transform: "translate(130.039 1512.897)",
    fill: "#fafcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M-115.544-1498.811h40.872l-40.872,40.973Z",
    transform: "translate(122.709 1505.774)",
    fill: "#004d43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M-101.867-1484.522h17.256l-17.256,17.156Z",
    transform: "translate(115.683 1498.475)",
    fill: "#fafcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M-64.154-1451.655l-4.642,4.642,14.33,14.632,4.945-4.844Z",
    transform: "translate(98.769 1481.729)",
    fill: "#004d43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRealpriceMenu);
export default __webpack_public_path__ + "static/media/logo-realprice-menu.306389a3ca30d5054715f09ed09fccf9.svg";
export { ForwardRef as ReactComponent };